import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.dashboard');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

declare let wiz: any;

@Component({
    standalone: false,
    selector: 'wiz-page-dashboard',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.dashboard/view.scss */
:host {
  display: block;
  height: 100%;
}`],
})
export class PageDashboardComponent implements OnInit {
    public stats: any[] = [];
    public recentProjects: any[] = [];
    public workItems: any[] = [];
    public alerts: any[] = [];
    public aiHistory: any[] = [];
    public assetCards: any[] = [];
    public assetParts: any = {};
    public assetTimeline: any[] = [];
    public fieldStats: any = {};
    public templates: any[] = [];
    public modelVersions: any[] = [];
    public achievements: any = { items: [] };
    public gapReview: any = { blockers: [], acceptance: [], roadmap: [] };
    public partsDist: any = {};
    public qualityDist: any = { high: 0, medium: 0, low: 0 };
    public loading: boolean = true;

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.load();
    }

    public async load() {
        this.loading = true;
        await this.service.render();
        try {
            // 두 카드 영역은 서로 의존하지 않으므로 동시에 요청해 초기 대기 시간을 줄인다.
            const [overview, assets] = await Promise.all([
                wiz.call("overview"),
                wiz.call("data_assets")
            ]);

            if (overview && overview.code === 200) {
                const data = overview.data || {};
                this.stats = data.stats || [];
                this.recentProjects = data.recentProjects || [];
                this.workItems = data.workItems || [];
                this.alerts = data.alerts || [];
                this.aiHistory = data.aiHistory || [];
            }

            if (assets && assets.code === 200) {
                const data = assets.data || {};
                this.assetCards = data.cards || [];
                this.assetParts = data.parts || {};
                this.assetTimeline = data.timeline || [];
                this.fieldStats = data.field || {};
                this.partsDist = data.partsDist || {};
                this.qualityDist = data.qualityDist || { high: 0, medium: 0, low: 0 };
                this.templates = data.templates || [];
                this.modelVersions = data.modelVersions || [];
                this.achievements = data.achievements || { items: [] };
                this.gapReview = data.gapReview || { blockers: [], acceptance: [], roadmap: [] };
            }
        } catch (error) {
            console.error('[dashboard/load]', error);
        } finally {
            this.loading = false;
            await this.service.render();
        }
    }
}

export default PageDashboardComponent;